import { ConfigServiceModel } from '@app/origami-api/services/config.service';
import FormSectionAppearance = ConfigServiceModel.FormSectionAppearance;
import { SectionMetadata } from '@app/shared/forms/dynamic-form/dynamic-form/dynamic-form-section/section-metadata/section-metadata.component';
export interface BaseItem {
  type: 'field' | 'group' | 'section';
  id: number;
  parent?: string;
  width?: number;
  sortOrder: number;
  name?: string;
  title?: string;
}

export interface LayoutSection extends BaseItem {
  type: 'section';
  appearance: FormSectionAppearance;
  default: boolean;
  name: string;
  title: string;
  collapsed?: boolean;
  active?: boolean;
  metadata?: SectionMetadata;
}

export interface LayoutGroup extends BaseItem {
  type: 'group';
  title: string;
  parent: string;
  name: string;
  width: number;
}

export interface LayoutField extends BaseItem {
  type: 'field';
  parent: string;
  width: number;
}

export enum Collection {
  Excluded = 'Excluded',
}
